import React from "react";
import { useSelector } from "react-redux";
import { List } from "antd";
import { itFaq } from "./itFaq";
import { enFaq } from "./enFaq";
import { getLocale, IT } from "../../../modules/language";

const { Item } = List;
const { Meta } = Item;

export const Faq = () => {
  const locale = useSelector(getLocale);
  return (
    <div className="faq">
      <h1>Surgery Tracker - Pagina FAQ</h1>
      <List
        itemLayout="horizontal"
        dataSource={locale === IT ? itFaq : enFaq}
        renderItem={(item) => (
          <Item>
            <Meta title={item.question} description={item.response} />
          </Item>
        )}
      />
    </div>
  );
};
